import { render } from "./SpotifyCallbackView.vue?vue&type=template&id=6aabb12c&scoped=true"
import script from "./SpotifyCallbackView.vue?vue&type=script&lang=js"
export * from "./SpotifyCallbackView.vue?vue&type=script&lang=js"

import "./SpotifyCallbackView.vue?vue&type=style&index=0&id=6aabb12c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aabb12c"]])

export default __exports__